import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const comboboxClearFn = /* @__PURE__ */ createRecipe('combobox-clear', {}, [])

const comboboxClearVariantMap = {}

const comboboxClearVariantKeys = Object.keys(comboboxClearVariantMap)

export const comboboxClear = /* @__PURE__ */ Object.assign(memo(comboboxClearFn.recipeFn), {
  __recipe__: true,
  __name__: 'comboboxClear',
  __getCompoundVariantCss__: comboboxClearFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: comboboxClearVariantKeys,
  variantMap: comboboxClearVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, comboboxClearVariantKeys)
  },
  getVariantProps: comboboxClearFn.getVariantProps,
})